import { render, staticRenderFns } from "./AnalitSortOrder.vue?vue&type=template&id=22ebdcc4&scoped=true"
import script from "./AnalitSortOrder.vue?vue&type=script&lang=js"
export * from "./AnalitSortOrder.vue?vue&type=script&lang=js"
import style0 from "./AnalitSortOrder.vue?vue&type=style&index=0&id=22ebdcc4&prod&lang=css"
import style1 from "./AnalitSortOrder.vue?vue&type=style&index=1&id=22ebdcc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ebdcc4",
  null
  
)

export default component.exports